"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _Icon = require("../../Icon");
var _StepperModule = _interopRequireDefault(require("../Stepper.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Step = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    active,
    children,
    completed = false,
    disabled = false,
    expanded = false,
    index = 0,
    last,
    classNames,
    onClick,
    allowClick,
    iconName,
    iconType
  } = _ref;
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const stepContent = childrenArray.map(stepContent => /*#__PURE__*/React.cloneElement(stepContent, {
    ...stepContent.props,
    active,
    completed,
    disabled
  }));
  const handleClick = e => allowClick && onClick?.(index, e);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _classify.default)(_StepperModule.default.stepWrapper, {
      [_StepperModule.default.active]: active,
      [_StepperModule.default.completed]: completed,
      [_StepperModule.default.expanded]: expanded,
      [_StepperModule.default.last]: last,
      [_StepperModule.default.disabled]: disabled,
      [_StepperModule.default.clickable]: allowClick
    }, classNames?.wrapper),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_StepperModule.default.stepWrapperCounter, {
      [_StepperModule.default.selected]: active,
      [_StepperModule.default.completed]: completed,
      [_StepperModule.default.expanded]: expanded,
      [_StepperModule.default.last]: last,
      [_StepperModule.default.disabled]: disabled,
      [_StepperModule.default.withIcon]: !!iconName
    }, classNames?.stepCounter)
  }, completed && !active ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: "check",
    type: _Icon.ICON_TYPE.solid,
    size: _Icon.ICON_SIZE.small,
    className: _StepperModule.default.stepIcon
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, iconName ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconName,
    className: _StepperModule.default.stepIcon,
    size: _Icon.ICON_SIZE.small,
    type: iconType
  }) : (index + 1).toString())), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_StepperModule.default.stepContent, classNames?.content)
  }, stepContent));
});
exports.Step = Step;